import React from 'react';
import '../styles/PatientSelection.css';

const PatientSelection = ({ patients, onSelect }) => {
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";

    // Handle formats like "01-09-2026 00:00:00" or "YYYY-MM-DDTHH:mm:ss"
    let datePart = dateString.split(' ')[0].split('T')[0];

    // Replace DD-MM-YYYY with MM/DD/YYYY for correct JS Date parsing
    let parseableDate = datePart;
    if (datePart.includes('-')) {
      const parts = datePart.split('-');
      if (parts.length === 3 && parts[2].length === 4) {
        // parts[0] is DD, parts[1] is MM, parts[2] is YYYY
        parseableDate = `${parts[1]}/${parts[0]}/${parts[2]}`;
      }
    }

    const date = new Date(parseableDate);
    if (isNaN(date.getTime())) {
      return datePart; // Fallback to raw date part if parsing completely fails
    }

    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    });
  };

  return (
    <>
      <div className="login-otp-icon-wrap">
        <div className="login-otp-icon-circle">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#2d8a5e" strokeWidth="2">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
            <circle cx="9" cy="7" r="4"></circle>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
          </svg>
        </div>
      </div>

      <h2 className="login-otp-heading">Select Patient</h2>
      <p className="login-otp-sub">Patients linked to your contact details with existing visits are shown below. Please choose a patient profile to continue.</p>

      <div className="patient-selection-container">
        {patients && patients.map((patient, index) => (
          <div
            key={index}
            className="patient-card"
            onClick={() => onSelect(patient)}
          >
            <div className="patient-card-avatar">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                <circle cx="12" cy="7" r="4"></circle>
              </svg>
            </div>
            <div className="patient-card-info">
              <div className="patient-card-name">
                {patient.firstName || patient.FirstName} {patient.lastName || patient.LastName}
              </div>
              <div className="patient-card-dob">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                  <line x1="16" y1="2" x2="16" y2="6"></line>
                  <line x1="8" y1="2" x2="8" y2="6"></line>
                  <line x1="3" y1="10" x2="21" y2="10"></line>
                </svg>
                DOB: {formatDate(patient?.dob)}
              </div>
            </div>
            <div className="patient-card-arrow">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="5" y1="12" x2="19" y2="12"></line>
                <polyline points="12 5 19 12 12 19"></polyline>
              </svg>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default PatientSelection;
